import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { Button, Input, Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import AppStore from "../../../stores/User/AppStore";
import IndustryTagDialog from "./dialog/IndustryTagDialog";
import OtherTagDialog from "./dialog/OtherTagDialog";
import TagEditDialog from "./dialog/TagEditDialog";
const TagPage: React.FC = (props) => {
  const { industryTag, otherTag } = AppStore;
  useEffect(() => {
    AppStore.getTag();
  }, []);
  const [visibles, setVisibles] = useState<{ [key: string]: any }>({
    industryTag: false,
    otherTag: false,
    editTag: false,
  });
  const updateVisibles = (key: string, value: any) => {
    visibles[key] = value;
    setVisibles({ ...visibles });
  };
  const [tagInfo, setTagInfo] = useState<{
    name: string;
    id: string;
  }>({ name: "", id: "" });
  const industryTagDom = industryTag.map((item) => (
    <div className={styles.industry_item} key={item.id}>
      <label>{item.name}</label>
      <div>
        <span
          className={styles.industry_item_btn}
          onClick={() => {
            updateVisibles("editTag", true);
            setTagInfo({ name: item.name, id: String(item.id) });
          }}
        >
          <EditOutlined style={{ color: "#1890ff" }} />
        </span>

        <span
          className={styles.industry_item_btn}
          onClick={(e) => e.stopPropagation()}
        >
          <Popconfirm
            title="是否删除该标签"
            okText="确认"
            cancelText="取消"
            onConfirm={() => {
              AppStore.removeTag(String(item.id), "1");
            }}
          >
            <DeleteOutlined style={{ color: "red" }} />
          </Popconfirm>
        </span>
      </div>
    </div>
  ));
  const otherTagDom = otherTag.map((item) => (
    <div className={styles.other_item} key={item.id}>
      <label>{item.name}</label>
      <div>
        <span
          className={styles.other_item_btn}
          onClick={() => {
            updateVisibles("editTag", true);
            setTagInfo({ name: item.name, id: String(item.id) });
          }}
        >
          <EditOutlined style={{ color: "#1890ff" }} />
        </span>

        <span
          className={styles.other_item_btn}
          onClick={(e) => e.stopPropagation()}
        >
          <Popconfirm
            title="是否删除该标签"
            okText="确认"
            cancelText="取消"
            onConfirm={() => {
              AppStore.removeTag(String(item.id), "2");
            }}
          >
            <DeleteOutlined style={{ color: "red" }} />
          </Popconfirm>
        </span>
      </div>
    </div>
  ));

  return (
    <>
      <div className={styles.content}>
        <section
          className={styles.industry_content}
          style={{ marginRight: "60px" }}
        >
          <div className={styles.title}>
            <span>行业标签列表</span>
            <Button
              type="primary"
              onClick={() => updateVisibles("industryTag", true)}
            >
              添加
            </Button>
          </div>
          <Input.Search
            allowClear
            style={{ width: "80%", marginTop: "12px" }}
            placeholder="输入标签名"
            onSearch={(v) => AppStore.getTag(v, "1")}
          />
          <div className={styles.industry_list}>{industryTagDom}</div>
        </section>
        <div className={styles.line}></div>
        <section
          className={styles.other_content}
          style={{ marginLeft: "60px" }}
        >
          <div className={styles.title}>
            <span>其他标签列表</span>
            <Button
              type="primary"
              onClick={() => updateVisibles("otherTag", true)}
            >
              添加
            </Button>
          </div>
          <Input.Search
            allowClear
            style={{ width: "80%", marginTop: "12px" }}
            placeholder="输入标签名"
            onSearch={(v) => AppStore.getTag(v, "2")}
          />
          <div className={styles.other_list}>{otherTagDom}</div>
        </section>
      </div>
      <IndustryTagDialog
        visible={visibles.industryTag}
        close={() => updateVisibles("industryTag", false)}
      />
      <OtherTagDialog
        visible={visibles.otherTag}
        close={() => updateVisibles("otherTag", false)}
      />
      <TagEditDialog
        visible={visibles.editTag}
        close={() => updateVisibles("editTag", false)}
        tagInfo={tagInfo}
      />
    </>
  );
};

export default observer(TagPage);
